export const defaultLanguage = 'nl-NL'
export const sitecoreProxy = '/sc-proxy'
export const ashxExtension = '.ashx'
export const aspxExtension = '.aspx'
export const defaultHeadingWeight = 3
